import { Attributes, Validation, ValueObject } from '@singularsystems/neo-core';

export default class NoteDetail extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    public refNo: string = "";

    public name: string = "";

    @Attributes.Nullable()
    @Attributes.Float()
    public amount: number | null = null;

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<NoteDetail>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Note Detail";
    }
}